import React from "react";

import {
  HorizontalAnswerBubblesQuestionSet,
  SingleQuestionAnswerBubble,
  SingleQuestionAnswerText,
} from "@/component-library";

/**
 * there is no difference between the A5_V2 and A5-R display from the clients point of view
 * so only one component is necessary
 */
export const A5AssessmentDisplay = ({ assessmentSummary }) => {
  return (
    <div className="A5AssessmentDisplay--grid">
      <div className="A5AssessmentDisplay--column">
        <div className="A5AssessmentDisplay--question_container">
          <div className="A5AssessmentDisplay--hr" />
          <HorizontalAnswerBubblesQuestionSet
            answers={assessmentSummary?.["Life Problems"]}
            optionColStyle={{ marginRight: 1, paddingBottom: 10, width: 34 }}
            questionAnswerClassName="align-items-center"
            questionSetCategory="Life Problems"
            questionSetOptions={[
              "No problem",
              "Mild",
              "Mild- Moderate",
              "Moderate",
              "Moderate- Severe",
              "Severe",
            ]}
          />
        </div>
      </div>

      <div className="A5AssessmentDisplay--column">
        <div className="A5AssessmentDisplay--question_container">
          <div className="A5AssessmentDisplay--hr" />
          <SingleQuestionAnswerBubble
            answerIds={assessmentSummary?.["Readiness to Change"]}
            questionSetCategory="Readiness to Change"
            questionSetOptions={["Not at all", "Very little", "Somewhat", "Much", "Very Much"]}
          />
        </div>
        <div className="A5AssessmentDisplay--question_container">
          <div className="A5AssessmentDisplay--hr" />
          <SingleQuestionAnswerText
            answers={assessmentSummary?.["Medical Problems"]}
            questionSetCategory="Medical Problems"
          />
        </div>

        <div className="A5AssessmentDisplay--question_container">
          <div className="A5AssessmentDisplay--hr" />
          <SingleQuestionAnswerText
            answers={assessmentSummary?.["Traumatic Events"]}
            questionSetCategory="Traumatic Events"
          />
        </div>
      </div>

      <div className="A5AssessmentDisplay--symptoms_column">
        <div className="A5AssessmentDisplay--question_container">
          <div className="A5AssessmentDisplay--hr" />
          <SingleQuestionAnswerText
            answerClassName={
              // only reduce text size if not None
              !Array.isArray(assessmentSummary?.["Symptoms"]) &&
              "A5AssessmentDisplay--symptom_answer_text"
            }
            answers={assessmentSummary?.["Symptoms"]}
            questionSetCategory="Symptoms"
          />
        </div>
      </div>
    </div>
  );
};
